export const classic = ({ routed, unrouted }) => [{
  type: 'div',
  attrs: [{ name: 'class', value: 'maui-mf-root' }],
  routes: [
    {
      type: 'header',
      attrs: [{
        name: 'class',
        value: 'maui-mf-root__header'
      }],
      routes: [
        {
          type: 'application',
          name: '@maui-mf/app-header'
        },
        {
          type: 'application',
          name: '@maui/app-gti/FeatureToggler',
        }
      ]
    },
    {
      type: 'div',
      attrs: [{
        name: 'class',
        value: 'maui-mf-root__main'
      }],
      routes: routed,
    },
    {
      type: 'div',
      attrs: [{
        name: 'class',
        value: 'maui-mf-root__unrouted'
      }],
      routes: unrouted,
    }
  ]
}]
